import classNames from 'classnames';
import React from 'react';

export interface FieldWrapperStartAdornmentProps {
  className?: string;
  size?: 'medium' | 'small';
}

export function FieldWrapperStartAdornment({
  children,
  className,
  size = 'medium'
}: React.PropsWithChildren<FieldWrapperStartAdornmentProps>) {
  return (
    <div className={classNames(
      'pointer-events-none absolute inset-y-0 left-0 flex items-center',
      size === 'medium' && 'pl-3',
      size === 'small' && 'pl-1.5',
      className
    )}>
      {children}
    </div>
  );
}

export interface FieldWrapperEndAdornmentProps {
  className?: string;
  size?: 'medium' | 'small';
}

export function FieldWrapperEndAdornment({
  children,
  className,
  size = 'medium'
}: React.PropsWithChildren<FieldWrapperEndAdornmentProps>) {
  return (
    <div className={classNames(
      'pointer-events-none absolute inset-y-0 right-0 flex items-center',
      size === 'medium' && 'pr-3',
      size === 'small' && 'pr-1.5',
      className
    )}>
      {children}
    </div>
  );
}

export interface FieldWrapperProps {
  className?: string;
}

export function FieldWrapperRoot({ children, className }: React.PropsWithChildren<FieldWrapperProps>) {
  return <div className={classNames('relative', className)}>{children}</div>;
}

export const FieldWrapper = Object.assign(FieldWrapperRoot, {
  StartAdornment: FieldWrapperStartAdornment,
  EndAdornment: FieldWrapperEndAdornment,
});

export default FieldWrapper;
